import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

// interfaces
import { OrderDetails } from 'src/app/core/interfaces/order-details';

@Component({
  standalone: true,
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss'],
  imports: [ NgClass ]
})
export class OrderDetailsComponent implements OnInit {

  /**
   * Inputs
   */
  @Input({ alias: 'classList' }) public ClassList: string = '';
  @Input({ alias: 'info', required: true }) public Data: OrderDetails = null;

  constructor() { }

  ngOnInit(): void {
  }

}
